import { type Conversation } from "shared/apiClient";
import { type Noticeboard } from "shared/lib";
import { useGetReportContent } from "shared/hooks";

export function useGetDevelopmentActivityText(
  conversation: Conversation | undefined | null,
  noticeboardData: Noticeboard | undefined | null,
): string {
  const { getConfig } = useGetReportContent({
    conversation,
    noticeboardData,
  });

  const { content: developmentActivityText } = getConfig(
    `enquiry.development_activity`,
  );

  return developmentActivityText;
}
